<template>
    <div class="form-group">
        <label :for="getFieldId" v-text="placeholder" v-if="placeholder"></label>
        <select :value="value"
                :name="name"
                :id="getFieldId"
                :required="required"
                :readonly="readonly"
                :disabled="disabled"
                class="form-control"
                @change="updateValue($event.target.value)">
            <option :value="noValue" v-text="emptyOption"></option>
            <slot></slot>
        </select>
    </div>
</template>
 <script>

     let Input = require('@/mixins/InputField')

     export default {

         mixins: [Input],

         props: {
             emptyOption: {
                 type: String,
                 required: false,
                 default: 'Select option...'
             },
             noValue:{
                 required: false,
                 default: '',
             }
         },

         methods: {
             updateValue(value) {
                 this.$emit('input', value);
                 this.$emit('change', value);
             }
         },
     }
 </script>
